export default "__VITE_PUBLIC_ASSET__1385a20b__"